export default {
	/**
	 * Set all admin fields
	 * @param {Array} adminFields 
	 */
	setAdminFields(state, adminFields) {
		state.all = adminFields
	},
}
